<template>
    <div class="c-wallet">
        <Card v-for="(card,i) in cards" :key="i" :card="card" :noedit="true" />
    </div>
</template>

<script>

import Card from '@/components/Cards/Card'
import WebSoc from '@/utils/WebSoc.js'

export default {
    props: ['btn','page'],
    computed: {
        session_id () { return this.$store.state.session_id },
        customer_id () { return this.$store.state.customer_id }
    },
    components: {
        Card
    },
    watch: {
        'btn.wallet_id' ( wallet_id ) { 
            this.getWallet(wallet_id);
        },
        'btn.width' ( width ) {
            this.setScale(width);
        }
    },
    data () {
        return {
            wallet: {},
            cards: []
        }
    },
    mounted () {
        this.getWallet(this.btn.wallet_id);
        this.setScale(this.btn.width);
    },
    methods: {
        getWallet ( wallet_id ) { 
            if ( !wallet_id ) return;
            WebSoc.SEND({ t: 'getWalletCards', data: { wallet_id, client_id: this.page.client_id, customer_id: this.customer_id, page_id: this.page_id, btnCode: this.btn.code } },resp => {
                //console.log('getWalletCards resp',resp);
                resp.wallet && ( this.wallet = resp.wallet );
                resp.card && this.cards.push(resp.card);
            })
            /*
            WebSoc.SEND('get',{ DB: 'wallets', _id },wallet => {
                if ( wallet.cards.length == 0 ) return console.log('NO CARDS')
                WebSoc.SEND('search',{ DB: 'cards', find: { $or: wallet.cards }},cards => {
                    this.cards = cards;
                })
            })
            */
        },
        setScale ( width ) {
            var scale = 1 / ( 414 / ( width - 30 ) ) ;
            this.$el.style.transform = 'scale('+scale+')'; 
            this.$el.style.backgroundColor = 'rgba(0,0,0,0)'
        }
    }
}

</script>

<style lang="scss">
.c-wallet {
    transform-origin: 0px 0px;
    transform: scale(0.9);
}    
</style>

